import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { CheckboxFilterGroup } from '../../generic/Filter';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import type { AnyFilter } from '../../../../shared/organizationPackages';
import { isValidSeverity } from '../../../../shared/organizationPackages';

const SEVERITY_OPTIONS = [
  { key: 'critical', label: 'Critical (9-10)' },
  { key: 'high', label: 'High (7-8.9)' },
  { key: 'medium', label: 'Medium (4-6.9)' },
  { key: 'low', label: 'Low (0.1-3.9)' },
  { key: 'unknown', label: 'Unknown' },
];

type Props = {
  setFilters: (filter: AnyFilter) => void;
};

/**
 * PackageInventoryFiltersVulnSeverity displays checkboxes which can be used to
 * filter packages by those that have vulns of specific severities.
 */
const PackageInventoryFiltersVulnSeverity: VoidFunctionComponent<Props> = ({ setFilters }) => {
  const severities = useSelector(PackageInventoryStore.selectors.getFiltersVulnSeverities);
  const onSelect = (severity: string, isChecked: boolean) => {
    if (!isValidSeverity(severity)) {
      return;
    }

    if (isChecked) {
      setFilters({ severities: [...severities, severity] });
    } else {
      setFilters({ severities: severities.filter(sev => sev !== severity) });
    }
  };
  return (
    <CheckboxFilterGroup
      title="Severity"
      options={SEVERITY_OPTIONS}
      selectedOptions={severities}
      onSelect={onSelect}
      testId="package-inventory-filters-vuln--severity"
    />
  );
};

export default PackageInventoryFiltersVulnSeverity;
